import {
  FETCH_TRIPMASTER_REQUEST,
  SAVE_TRIPMASTER_REQUEST,
  DELETE_TRIPMASTER_REQUEST,
} from "./actionTypes";

export const fetchTripmaster = (payload) => ({
  type: FETCH_TRIPMASTER_REQUEST,
  payload,
});

export const saveTripmaster = (data) => ({
  type: SAVE_TRIPMASTER_REQUEST,
  payload: data,
});

export const deleteTripmaster = (payload) => ({
  type: DELETE_TRIPMASTER_REQUEST,
  payload,
});
